import { useEffect, useState } from "react";

const JOEY_THINKING = "https://customer-assets.emergentagent.com/job_648de01e-2b76-4a92-ab16-261bd9620d49/artifacts/mf9s3xp3_deb056c-8c4-ed5-5d48-4283b526a245_ALV_7106_1_.jpeg";

const DEFAULT_STEPS = [
  "Reviewing your brand...",
  "Analyzing trademark exposure...",
  "Drafting your personalized report...",
];

export const LoadingScreen = ({ steps = DEFAULT_STEPS, brandName }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setActive(1), 1400);
    const t2 = setTimeout(() => setActive(2), 2900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const title = brandName ? `Reviewing ${brandName}...` : steps[0];

  return (
    <div
      className="container-narrow"
      style={{ padding: "3rem 1.25rem", minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}
      data-testid="loading-screen"
    >
      <img
        src={JOEY_THINKING}
        alt="Joey reviewing your brand"
        data-testid="loading-joey-photo"
        style={{
          width: 160, height: 160, borderRadius: "50%", objectFit: "cover",
          border: "4px solid var(--navy)", boxShadow: "6px 6px 0 0 var(--yellow)",
          marginBottom: "1.75rem",
        }}
      />
      <p className="eyebrow" style={{ marginBottom: "0.4rem" }}>Reviewing your business</p>
      <h2 style={{ fontSize: "1.5rem", margin: "0 0 1.5rem", textAlign: "center" }} data-testid="loading-title">
        {title}
      </h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.7rem", alignItems: "flex-start" }}>
        {steps.map((s, idx) => {
          const cls = idx < active ? "loading-step done"
            : idx === active ? "loading-step active"
            : "loading-step pending";
          return (
            <div key={s} className={cls} data-testid={`loading-step-${idx}`}>
              <span className="dot" />
              <span>{s}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
